import React from 'react';
import { connect } from 'react-redux';
import EditingDataHistoryDialog from '../components/editingDataHistoryDialog';
import * as objectHistory from '../store/objectHistorySlice';
import { objectHistoryNames, objectHistorySelectors } from '../store/objectHistorySlice';
import AccountsHistoryTable from '../components/accountsHistoryTable';
import { showModalMessage } from '../store/modalsSlice';
import AccountsHistoryTableHeader from '../components/accountsHistoryTableHeader';
import { accountsSelectors } from '../store/accountsSlice';

class AccountsHistoryDialog extends EditingDataHistoryDialog {
  get dataId() {
    return this.props.id;
  }

  get Title() {
    return 'AI accounts history';
  }

  renderTable(tableProps) {
    return <AccountsHistoryTable {...tableProps}/>
  }

  renderBeforeContent() {
    const objectData = this.props.selectedAccount(this.props.id);
    return <AccountsHistoryTableHeader objectData={objectData}/>
  }

  getLoaderMessage() {
    return 'AI accounts history loading...';
  }

}

const mapStateToProps = (state) => ({
  objectState: objectHistorySelectors.accounts(state),
  selectedAccount: (id) => accountsSelectors.selectById(state, id),
});

const actionCreators = {
  fetchHistory: (accountId) => objectHistory.fetchHistory(accountId, objectHistoryNames.accounts),
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(AccountsHistoryDialog);



// WEBPACK FOOTER //
// ./src/containers/accountsHistoryDialog.js